import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { useLang } from "@/i18n";
import Seo from "@/components/Seo";
import { ArticleCard } from "@/components/ArticleCard";
import { NewsletterBox } from "@/components/NewsletterBox";

export default function Reviews() {
  const { lang, t } = useLang();
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/articles", { params: { lang, category: "Review" } }).then((r) => setArticles(r.data));
  }, [lang]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <Seo title={lang === "it" ? "Recensioni attrezzatura boxe e kickboxing" : "Boxing & kickboxing gear reviews"} description={lang === "it" ? "Guanti, sacchi, fasce e protezioni provati e confrontati per chi si allena davvero." : "Gloves, bags, wraps and protection tested and compared for people who actually train."} />
      <span className="text-xs font-mono uppercase tracking-[0.25em] text-[#F59E0B]">{t("reviews_title")}</span>
      <h1 className="mt-2 font-heading text-4xl sm:text-5xl font-black uppercase text-white">{t("reviews_title")}</h1>
      <p className="mt-3 text-zinc-400 max-w-xl">{t("reviews_sub")}</p>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {articles.map((a) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>

      <div className="mt-14">
        <NewsletterBox variant="reviews" />
      </div>
    </div>
  );
}
